import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './styles/BestDealInput.css';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config.js';

const BestDealInput = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [inputDealValue, setInputDealValue] = useState('');
  const [minPrice, setMinPrice] = useState(null);
  const [maxPrice, setMaxPrice] = useState(null);
  const [error, setError] = useState('');

  const location = state?.location;
  const currentAddress = state?.currentAddress;
  const user = state?.user;
  const productName = state?.productName;
  const productImage = state?.productImage;
   const productUnits = state?.productUnits;

  // 🔁 Fetch min/max price on load
  useEffect(() => {
    const fetchProductPriceRange = async () => {
      try {
        const productRef = doc(db, 'products', productName);
        const productSnap = await getDoc(productRef);

        if (productSnap.exists()) {
          const data = productSnap.data();
          setMinPrice(data.minimum_price);
          setMaxPrice(data.maximum_price);
        } else {
          console.warn('Product not found in Firestore.');
        }
      } catch (err) {
        console.error('Error fetching price range:', err);
      }
    };

    fetchProductPriceRange();
  }, [productName]);

  // ✅ Handle "Get Best Deal" with optional input validation
  const handleGetDeals = () => {
    const input = parseFloat(inputDealValue);

    if (inputDealValue) {
      // If user entered something, validate range
      if (isNaN(input)) {
        setError('Please enter a valid number.');
        return;
      }

      if (minPrice !== null && maxPrice !== null) {
        if (input < minPrice || input > maxPrice) {
          setError(`Please enter a valid price`);
          return;
        }
      }
    }

    // ✅ Clear error and navigate
    setError('');
    navigate('/dealdetails', {
      state: {
        productName,
        location,
        currentAddress,
        user,
        inputDealValue,
        productImage
      }
    });
  };

  return (
    <div className="deal-container">
      <div className="user-header">
        <div className="profile">
          <img src={user?.photoURL} alt="avatar" className="avatar" />
          <div className="user-info-text">
            <h4>{user?.name}</h4>
            <p>{user?.email}</p>
          </div>
          <div className="product-info">
             <img src={productImage} alt="product" className="avatar" />
             <p className="product-name">{productName}</p>
         </div>

        </div>
      </div>

      <div className="location">
        <span className="location-icon">📍</span>
        <span>{currentAddress}</span>
      </div><br/>

      <div className="deal-input-section">
        <p className="deal-label">
          At what price your regular shop is offering <b>{productName}/{productUnits}</b> (optional)
        </p>

        <input
          type="number"
         // placeholder={`Between ₹${minPrice} - ₹${maxPrice}`}
          className="deal-input"
          value={inputDealValue}
          onChange={(e) => setInputDealValue(e.target.value)}
        />

        {error && <p className="error-text">{error}</p>}

        <button className="deal-button" onClick={handleGetDeals}>
          Get the Best Deal
        </button>
      </div>
    </div>
  );
};

export default BestDealInput;
